import styled from '@emotion/styled';
import { DarkModeRounded, LightModeRounded } from '@mui/icons-material';
import { ComponentProps } from 'react';
import { useSettingValue, VisualThemeSetting } from '~/modules/Settings/sharedSettings';

export default function ThemeToggle(props: ComponentProps<typeof ToggleButton>) {
  const [theme, setTheme] = useSettingValue(VisualThemeSetting);
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <ToggleButton
      {...props}
      type="button"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={label}
      aria-pressed={isDark}
      title={label}>
      {isDark ? <LightModeRounded /> : <DarkModeRounded />}
    </ToggleButton>
  );
}

const ToggleButton = styled.button`
  width: 44px;
  height: 44px;
  min-width: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--walky-border);
  border-radius: 8px;
  background: var(--walky-surface-raised);
  color: var(--walky-ink);
  box-shadow: var(--walky-shadow);
  cursor: pointer;
  transition:
    background 160ms ease,
    color 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;

  &:hover,
  &:focus-visible {
    color: white;
    background: var(--walky-orange);
    border-color: var(--walky-orange);
    transform: translateY(-1px);
    outline: none;
  }

  svg {
    width: 23px;
    height: 23px;
  }
`;
